import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { FaSearch } from 'react-icons/fa';

function SearchBar({ onSearch, initialValue = '' }) {
  const [searchTerm, setSearchTerm] = useState(initialValue);
  const [isFocused, setIsFocused] = useState(false);

  // Keep the input in sync when the parent supplies a new initialValue
  // (e.g. navigation from the home hero's keyword mode with ?q=...).
  useEffect(() => {
    setSearchTerm(initialValue);
  }, [initialValue]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSearch(searchTerm);
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className={`relative transition-all duration-300 ${isFocused ? 'scale-[1.01]' : ''}`}>
        <FaSearch className="absolute left-4 top-1/2 -translate-y-1/2 text-white/30 text-xs" />
        <input
          type="text"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          placeholder="Search papers..."
          className="w-full py-3 pl-10 pr-24 glass-strong rounded-lg text-sm text-white placeholder-white/30 focus:outline-none focus:ring-1 focus:ring-yellow-300/30 transition-all duration-200"
        />
        <motion.button
          type="submit"
          className="absolute right-1.5 top-1/2 -translate-y-1/2 bg-yellow-300 text-gray-900 rounded-md px-4 py-1.5 text-xs font-bold uppercase tracking-wider hover:bg-yellow-200 transition-colors duration-200"
          whileHover={{ scale: 1.03 }}
          whileTap={{ scale: 0.97 }}
        >
          Search
        </motion.button>
      </div>
    </form>
  );
}

export default SearchBar;
